{
  "032062c35f0ec6c7": "No se pudieron cargar las referencias.",
  "0355dadf5f4baffe": "Sigue cuando tu contacto se registra en su lugar de trabajo usando tu código de referido.",
  "039f155d5e0eb4bc": "Bonificación de referido",
  "098f25dceaa93fbd": "Enviar referencia",
  "0faec61d36bda7bd": "¡Regístrate en Clipboard Health usando mi enlace de referido!",
  "117fe58fb0965b3b": "No se pudo cargar el código de referencia.",
  "11fc1404d2a4c96f": "Envía tu enlace de referido personalizado a tus contactos del lugar de trabajo.",
  "25d092234974cd8b": "Presenta a tus contactos laborales a Clipboard Health enviándoles tu enlace de referencia.",
  "3d44337010bfbdf7": "Creado el",
  "4258c29ea4d12fbe": "Refiere un nuevo lugar de trabajo",
  "596f52c9bbfdeb6f": "Outlook / Hotmail / Live",
  "5dbfc76de9a61cb2": "Vista de administrador",
  "61cefb5ee7454e7d": "Incentivo: {{incentive}}",
  "664b0a5c07ecbd94": "Bonificación por referido",
  "6fa2f04b36ca4a14": "Lee los términos y requisitos del programa.",
  "76ffc344c6ae80b5": "Referencias",
  "7cdc830f14ab65a1": "Créditos de turno",
  "86a5bfa5d2dc25ff": "Comparte el enlace de referencia",
  "89f8087ecd480ef3": "Sigue tus referidos",
  "920e413c7d411b61": "Estado",
  "942087cc2d41e013": "Reintentar",
  "969ccbd3cf6300ec": "Correo electrónico",
  "a1630b6d262decc2": "Nombre del lugar de trabajo",
  "ad6f1f46a0d887fa": "¡Gana tu referido!",
  "bd2ba12499df5239": "Comparte tu enlace de referido",
  "c193a5735f1723aa": "¡Hola!\n\nHe estado utilizando Clipboard Health y me ha parecido súper útil para obtener acceso a cobertura de turno confiable. El registro es fluido y la aplicación es muy fácil de usar.\n\nCreo que deberías registrarte en Clipboard Health. Me parece súper útil para acceder a cobertura de turno confiable. ¡Tienes acceso a ETA profesional, chat en la aplicación, reemplazo urgente de turnos y más!\n\nRegístrate usando mi código de referido y ganarás instantáneamente {{incentiveAmount}} créditos una vez que publiques tu primer turno (los créditos se aplicarán desde el primer turno en adelante): {{referralUrl}}\n\n¡Creo que te encantará!\n\nMis mejores deseos,\n\n{{fullName}}",
  "d19a15c70437ed6e": "Gmail",
  "d637a2187ef38917": "Envía tu enlace de referencia a otros lugares de trabajo. También puedes copiar el enlace y compartirlo a través de redes sociales o mensajes de texto.",
  "dbf362d4f210c780": "Copiar enlace",
  "dc634dfbcce23ba4": "No hay referencias aún",
  "dcd1d5223f73b3a9": "Nombre",
  "ea61bc15688d1e48": "¡Copiado!",
  "f408535bacccfc1d": "Código de referido",
  "fe17ed8e33cb2efd": "Variante: {{variant}}"
}
